import { track } from "@/lib/track";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import api from "@/lib/api";
import { btnPrimary, btnOutline, overline } from "@/components/kit";
import { useUI } from "@/context/UIContext";
import { ArrowRight } from "lucide-react";

export function CityProjects({ city }) {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api.get("/projects", { params: { city } }).then((r) => setProjects(r.data)).catch(() => {});
  }, [city]);

  if (projects.length === 0) return null;
  return (
    <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 md:py-24" data-testid="city-projects">
      <Reveal><span className={overline}>Nos réalisations à {city}</span></Reveal>
      <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {projects.map((p, i) => (
          <Reveal key={p.id} delay={i % 3}>
            <div className="group relative overflow-hidden rounded-2xl border border-ink/10">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/80 to-transparent p-6">
                <span className="text-[11px] uppercase tracking-[0.2em] text-lime">{p.category}</span>
                <h3 className="mt-1 font-serif text-2xl text-white">{p.title}</h3>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

export function CityCTA({ city }) {
  const { setCallbackOpen } = useUI();
  return (
    <section className="border-t border-ink/10 bg-mist">
      <div className="mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28">
        <Reveal>
          <h2 className="max-w-3xl font-serif text-4xl font-medium leading-none tracking-tight text-ink md:text-6xl">
            Votre événement à <span className="italic text-lime-dim">{city}</span> commence ici.
          </h2>
        </Reveal>
        <Reveal delay={1}>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/devis" className={btnPrimary} data-testid="city-devis-btn">Déposer mon brief <ArrowRight size={16} /></Link>
            <button onClick={() => { track("click_rappel"); setCallbackOpen(true); }} className={btnOutline}>Être rappelé</button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
